"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.palette = void 0;
var _colors_scss_1 = __importDefault(require("./_colors.scss"));
exports.palette = {
    mode: 'light',
    common: {
        black: _colors_scss_1.default['common-black'],
        white: _colors_scss_1.default['common-white'],
    },
    primary: {
        light: _colors_scss_1.default['primary-light'],
        main: _colors_scss_1.default['primary'],
        dark: _colors_scss_1.default['primary-dark'],
    },
    secondary: {
        light: _colors_scss_1.default['secondary-light'],
        main: _colors_scss_1.default['secondary'],
        dark: _colors_scss_1.default['secondary-dark'],
    },
    error: {
        light: _colors_scss_1.default['error-light'],
        main: _colors_scss_1.default['error'],
        dark: _colors_scss_1.default['error-dark'],
    },
    warning: {
        light: _colors_scss_1.default['warning-light'],
        main: _colors_scss_1.default['warning'],
        dark: _colors_scss_1.default['warning-dark'],
    },
    info: {
        light: _colors_scss_1.default['info-light'],
        main: _colors_scss_1.default['info'],
        dark: _colors_scss_1.default['info-dark'],
    },
    success: {
        light: _colors_scss_1.default['success-light'],
        main: _colors_scss_1.default['success'],
        dark: _colors_scss_1.default['success-dark'],
    },
    text: {
        primary: _colors_scss_1.default['text-color'],
        secondary: _colors_scss_1.default['text-muted'],
    },
    divider: _colors_scss_1.default['border-light'],
    background: {
        default: _colors_scss_1.default['bg-default'],
        paper: _colors_scss_1.default['bg-paper'],
    },
    grey: {
        50: _colors_scss_1.default['gray-25'],
        100: _colors_scss_1.default['gray-25'],
        200: _colors_scss_1.default['gray-25'],
        300: _colors_scss_1.default['gray-25'],
        400: _colors_scss_1.default['gray-50'],
        500: _colors_scss_1.default['gray-50'],
        600: _colors_scss_1.default['gray-50'],
        700: _colors_scss_1.default['gray-75'],
        800: _colors_scss_1.default['gray-75'],
        900: _colors_scss_1.default['gray-100'],
        A100: _colors_scss_1.default['gray-25'],
        A200: _colors_scss_1.default['gray-50'],
        A400: _colors_scss_1.default['gray-75'],
        A700: _colors_scss_1.default['gray-100'],
    },
};
